import type { AccountFeature as GQLItem } from '../../../generated/internal.graphql';

/** An enabled feature-flag row; an absent `accountId` marks a creation-time default, not a live fallback. */
export type AccountFeature = {
  name: string;
  accountId?: number;
};

export const fromGql = (item: GQLItem): AccountFeature => ({
  name: item.feature,
  accountId: item.accountId ?? undefined,
});
